/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Button } from '@bottlebooks/gatsby-theme-base';
import filterIcon from '../../assets/filter.svg';
import { Trans } from '@lingui/macro';

export default function FiltersToggleButton({
  filtersHidden,
  onToggle,
  className,
}) {
  return (
    <Button
      onClick={onToggle}
      variant="text"
      sx={{
        backgroundColor: 'light',
        color: 'primary',
        justifyContent: 'space-between',
        paddingY: '12px',
        boxSizing: 'content-box',
        width: '100%',
        paddingX: 3,
        marginX: -3,
      }}
      className={className}
    >
      {filtersHidden ? (
        <Trans>Show filters</Trans>
      ) : (
        <Trans>Hide filters</Trans>
      )}
      <img src={filterIcon} width={20} height={20} alt="" />
    </Button>
  );
}
